import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import { DashboardAcompProducaoTableSemanal, Semana } from "../../../components/classes/DashAcompProducao";

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function GridJustificativas(
    props: DashboardOtifGridPropsTypes
) {
    const { t } = useTranslation();

    const [rows, setRows] = useState<Data>([]);

    const columns: GridColumns = [
        {
            field: "semana",
            headerName: t("common.week"),
            type: "string",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            valueFormatter: ({ value }) => value.descricao
        },
        {
            field: "otif",
            headerName: t("common.otif"),
            type: "string",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
            renderCell: (item) => {
                return item.row.otif == 100 ? <AssignmentTurnedInIcon color="success" /> : <AssignmentLateIcon color="warning" />;
            },
        },
        {
            field: "statusEntrega",
            headerName: t("common.status"),
            type: "string",
            width: 100,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "quantidadePlanejada",
            headerName: t("common.plannedQuantity"),
            type: "string",
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "quantidadeRealizada",
            headerName: t("common.accomplishedQuantity"),
            type: "string",
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "quantidadeDesvio",
            headerName: t("common.quantityDeviation"),
            type: "string",
            width: 200,
            editable: false,
            align: "center",
            headerAlign: "center",
        }
    ];

    useEffect(() => {
        if (props.data) {
            fillTable();
        }
    }, [props]);

    const fillTable = () => {
        let gridData: Data = [];
        props.data?.forEach(
            (item: DashboardAcompProducaoTableSemanal, index: number) => {
                gridData.push({
                    ...item,
                    id: index
                });
            }
        );

        setRows(gridData);
    }

    return (
        <div style={{ height: "40vh" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                rowsPerPageOptions={[50, 100, 250, 500]}
                onRowClick={(x) => {
                    props?.openJustificativas(x.row)
                }}
            />
        </div>
    );
}

interface DashboardOtifGridPropsTypes {
    data?: DashboardAcompProducaoTableSemanal[],
    openJustificativas: any
}